import Loader from "react-loader-spinner";
import { faMoneyCheckAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Button, Form, FormGroup, Modal } from "react-bootstrap";
import { getAllBankAccount, createChequeBook } from "../store/api/DocumentsAPI";
import { useEffect, useRef, useState } from "react";
import { CheckLg } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";

const ModalChequeBook = (props) => {
    const { popData, setPopData } = props;
    const { Show } = popData;
    const frm = useRef();
    const submitData = useRef({});
    const [error, setError] = useState(null);
    const [bankList, setBankList] = useState({ Data: [] });

    function close() {
        setPopData({
            Show: false
        })
        setError(null);
        submitData.current = {};
    }
    function setData(e) {
        submitData.current[e.target.name] = e.target.value;
    }
    function onSubmit() {
        if ((submitData.current.BankID ?? "") === "") {
            setError({ Variant: "danger", Message: " حساب انتخاب نشده است" });
            return;
        }
        if ((submitData.current.FirstPageNo ?? "") === "") {
            setError({ Variant: "danger", Message: " شماره آغازین دسته چک وارد نشده است" });
            return;
        }
        if ((submitData.current.PageCount ?? "") === "") {
            setError({ Variant: "danger", Message: " تعداد برگه مشخص نشده است" });
            return;
        }
        const onSuccess = (res) => {
            if (res === "Success") {
                setError({ Variant: "success", Message: "ثبت با موفقیت انجام شد" });
                frm.current.reset();
                submitData.current = {};
            }
            else if (res.Error) {
                setError({ Variant: "danger", Message: res.Error });
            }
        }
        const bank = bankList.Data.find(b => Number(b.ID) === Number(submitData.current.BankID));
        submitData.current.BankName = bank.BankName;
        submitData.current.BankAccountNo = bank.BankAccountNo;
        createChequeBook(submitData.current, onSuccess)
    }
    useEffect(() => {
        if (Show) {
            getAllBankAccount("", setBankList);
        }
    }, [Show])
    return (
        <Modal size="sm" show={Show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faMoneyCheckAlt} size="lg" />&nbsp;
                    ایجاد دسته چک
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <form ref={frm}>
                    <FormGroup>
                        <label>انتخاب حساب: </label><span style={{ color: "red" }}>*</span>
                        {
                            bankList === "PENDING" &&
                            <div className="form-control">
                                <Loader type="BallTriangle" color="#bb1370" height={20} width={20} style={{ display: "inline-block" }} />&nbsp;
                                در حال بارگذاری لیست
                            </div>
                        }
                        {
                            bankList?.Data && Array.isArray(bankList.Data) &&
                            <select className="form-control" name="BankID" onChange={setData}>
                                <option value="">انتخاب کنید</option>
                                {bankList.Data.map((item, i) => <option value={item.ID} key={i}>{item.BankMixedName}</option>)}
                            </select>
                        }

                    </FormGroup>
                    <FormGroup>
                        <label>
                            شماره آغازین دسته چک:
                        </label><span style={{ color: "red" }}>*</span>
                        <Form.Control type="number" name="FirstPageNo" onChange={setData} />
                    </FormGroup>
                    <FormGroup>
                        <label>تعداد برگه:</label><span style={{ color: "red" }}>*</span>
                        <Form.Control type="number" name="PageCount" onChange={setData} />
                    </FormGroup>
                    {
                        error && <Alert variant={error.Variant}><label className="scThin" style={{ overflow: "auto", maxWidth: "220px" }}> {error.Message}</label>
                            <FontAwesomeIcon icon={faTimes} size="lg" style={{ float: "left" }} onClick={() => setError(null)} />
                        </Alert>
                    }
                    <div>
                        <Button variant="success" className="group-Btn mt-2" onClick={onSubmit}><CheckLg size={16} />&nbsp;ثبت دسته چک</Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}
export default ModalChequeBook;